import { render } from "./FishTableEntry.vue?vue&type=template&id=637d57bf&scoped=true"
import script from "./FishTableEntry.vue?vue&type=script&lang=js"
export * from "./FishTableEntry.vue?vue&type=script&lang=js"

import "./FishTableEntry.vue?vue&type=style&index=0&id=637d57bf&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637d57bf"]])

export default __exports__